/**
 * Created by Ning Jiang on 10/10/2018.
 */

import {Presentation, PresentationState} from "@nolimitcity/slot-game/bin/core/gamecontroller/presentations/Presentation";
import {WGEngineManager} from "../../../engine/WGEngineManager";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {NudgeEvents, WGEnginePlayer} from "../../../engine/WGEnginePlayer";
import {WGParsedGameData} from "../../../server/data/WGParsedGameData";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {IResizeData} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {TweenLite} from "gsap";
import {GameSetting} from "@nolimitcity/slot-game/bin/core/setting/GameSetting";
import {Helper} from "@nolimitcity/slot-game/bin/core/utils/Helper";
import {WGGameConfig} from "../../../WGGameConfig";
import {WarriorGraveyardGameModuleConfig} from "../../../WarriorGraveyardGameModuleConfig";
import {GameMode} from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";
import {SpinEvent} from "@nolimitcity/slot-game/bin/core/spin/event/SpinEvent";
import {TimelineSprite} from "@nolimitcity/slot-launcher/bin/animation/TimelineSprite";
import {SoundManager} from "../../../resource/sound/SoundManager";
import {WGSoundConfig} from "../../../WGSoundConfig";

export class WildEvents {
    public static readonly SPIN_WILD_MULTIPLIER_WITH_SYMBOL: string = "wildEvent_spin_wild_multiplier_with_symbol";
}

export class WildNudgePresentation extends Presentation {
    private _nudgeData: WGParsedGameData;
    public static _nudgeSteps: number[];
    private _doReelNudge: Boolean[] = [false, false, false, false, false, false];
    private _wildMultipliers: number[] = [];
    static _wildNudgeStarted: boolean = false;
    // Multiplier items
    public static _wildMultiplierContainer: PIXI.Container[] = [];
    private _wildMultiplieronSymbols: number[] = [-1, 1, 1, 1, 1, -1];
    private _x: number = 0;
    private _symWinState: boolean[][];
    public static _isWarriorAttack: boolean = false;
    private _wildMulitplierGlow: TimelineSprite[] = [];
    private _abortSounds: boolean = false;
    private _wildNudgesoundX1reels: number[];

    /**
     * override this function to create wild multiplier container
     * and resize them when initialization called.
     */
    public initialization(): void {
        this.createWildMultiContainersForMiddleReels();
        WildNudgePresentation._wildMultiplierContainer.forEach((container: PIXI.Container, index: number) => {
            container.pivot.set(container.width * 2, container.height);
        });
        this.onResize();
    }

    /**
     * override this function listen
     * REEL_NUDGE_STEP_COMPLETED -> to do stuff when single step of nudge completed
     * SPIN_WILD_MULTIPLIER_WITH_SYMBOL -> spin multipliers with symbols in spin start.
     */
    public addEventListeners(): void {
        EventHandler.addEventListener(this, WildEvents.SPIN_WILD_MULTIPLIER_WITH_SYMBOL, (event: GameEvent) => {
            this.spinMultiplierWithSymbol(event.params[0]);
        });
    }

    /**
     * function to do stuff on each nudge step completed, particularly increasing multiplier
     * @param reelId
     */
    private nudgeStepCompleted(reelId: number, isWarriorAttack: boolean = false): void {
        let container = WildNudgePresentation._wildMultiplierContainer[reelId - 1];
        const multiplier = isWarriorAttack ? 1 : ++this._wildMultiplieronSymbols[reelId];
        const multiplierNum = new PIXI.Sprite(GameResources.getTextures("mult_fr_" + (multiplier).toString())[0]);
        if (this._nudgeData.mode === GameMode.FREESPIN && !this._wildNudgesoundX1reels.includes(reelId)) { // #288
            WarriorGraveyardGameModuleConfig.stickMuliplier.updateMulitplier(reelId, true);
        }


        if (!container.visible) {
            container.visible = true;
        }

        let glowAnim: TimelineSprite = this._wildMulitplierGlow[reelId - 1];
        container.children.length > 1 && container.removeChildAt(1);
        multiplierNum.position.x = this._x;
        container.addChild(multiplierNum);

        glowAnim.position.set(container.position.x + 20, container.position.y);
        this.pTimeline.to(container.scale, 0.05, {x: 0.4, y: 0.4}, this.pTimeline.time());
        this.pTimeline.add(glowAnim.getAnimationAutoShowHide(true, true), this.pTimeline.time());
        this.pTimeline.to(container.scale, 0.05, {x: 0.3, y: 0.3}, this.pTimeline.time() + 0.05);


    }

    public static showMulitplierOnRestore(reelId: number, multiplier: number): void {
        const container:PIXI.Container = WildNudgePresentation._wildMultiplierContainer[reelId - 1];
        let multiplierNum = new PIXI.Sprite(GameResources.getTextures("mult_fr_" + (multiplier).toString())[0]);
        if (!container.visible) {
            container.visible = true;
        }
        container.children.length > 1 && container.removeChildAt(1);
        multiplierNum.position.x = (container.children[container.children.length - 1].x + (container.children[container.children.length - 1] as PIXI.Sprite).width) - 10
        container.addChild(multiplierNum);
    }

    /**
     * function to create wil multiplier container for middle reels
     * all containers of each reel has a single parent container.
     */
    private createWildMultiContainersForMiddleReels(): void {
        for (let i:number = 0; i < 4; i++) {
            const multiplierContainer: PIXI.Container = new PIXI.Container();
            WildNudgePresentation._wildMultiplierContainer.push(multiplierContainer);
            const xImage = new PIXI.Sprite(GameResources.getTextures("mult_fr_x")[0]);
            const imageOne = new PIXI.Sprite(GameResources.getTextures("mult_fr_1")[0]);
            multiplierContainer.visible = false;
            multiplierContainer.scale.set(0.3);

            multiplierContainer.addChild(xImage);
            this._x = (multiplierContainer.children[multiplierContainer.children.length - 1].x + (multiplierContainer.children[multiplierContainer.children.length - 1] as PIXI.Sprite).width) - 10;
            multiplierContainer.addChild(imageOne);

            const glowAnim: TimelineSprite = new TimelineSprite(GameResources.getTextures("wildMultiplierGlow"));
            glowAnim.blendMode = PIXI.BLEND_MODES.ADD;
            glowAnim.anchor.set(0.5);
            glowAnim.visible = false;
            glowAnim.scale.set(0.8);
            this._wildMulitplierGlow.push(glowAnim);
            this.addChild(glowAnim, multiplierContainer);
        }
    }

    /**
     * resize function to handle position of multipliers
     * @param resizeData
     */
    public onResize(resizeData?: IResizeData): void {
        WildNudgePresentation._wildMultiplierContainer.forEach((container: PIXI.Container, index: number) => {
            container.position.set((120 * (index + 1.45)), 199 * 2.1);
        });
    }

    public checkForActivation(data: WGParsedGameData): boolean {
        // data.freespinsLeft===0 added to fix #234
        WGEnginePlayer.noWin = (data.singleWin === 0 && (data.mode === GameMode.NORMAL || data.freespinsLeft === 0)); // always nudge in Freespin
        return (data.wildMultipliers.filter(value => (value > 0)).length > 0);
    }

    public setParsedGamedData(data: WGParsedGameData): void {
        this._abortSounds = false;
        this._wildMultipliers = [...data.wildMultipliers];
        this._nudgeData = data;
        this._symWinState = data.symbolWinStates;
        WildNudgePresentation._isWarriorAttack = data.triggerWarriorPay;
        WarriorGraveyardGameModuleConfig.stickMuliplier._wildReelsiD = [-1, 1, 1, 1, 1, -1];
        this._wildNudgesoundX1reels = [];
        for (let i:number = 0; i < this._wildMultipliers.length; i++) {
            if (this._wildMultipliers[i] === 1) {
                this._wildNudgesoundX1reels.push(i);
            }
        }
    }

    /**
     * resize is called so that multiplier repositioned before presentation begins
     * steps nudge is added to timeline
     * also, reels that do not nudge but has multiplier will be showed from here.
     */
    public getPresentation(): void {
        EventHandler.addEventListener(this, NudgeEvents.REEL_NUDGE_STEP_COMPLETED, (event: GameEvent) => {
            this.nudgeStepCompleted(event.params[0]);
        });
        this.onResize();
        const steps: number[] = this.getStepsForNudge();
        WildNudgePresentation._wildNudgeStarted = true;
        WildNudgePresentation._nudgeSteps = steps;
        for (let i = 0; i < steps.length; i++) {
            if (this._doReelNudge[i]) {
                this.pTimeline.add(()=>{
                });
                // duration += (this._nudgeData.totalWin === 0 && this._nudgeData.mode === GameMode.NORMAL) ? 0 : (0.5 * Math.abs(steps[i]));
                let nudgeUp: boolean = this._wildMultipliers[i] < 0;
                for (let j = 0; j < Math.abs(this._wildMultipliers[i]); j++) {
                    // calling for 1 step at a time.
                    this.pTimeline.add(WGEngineManager.getReel(i).nudge(1, nudgeUp));
                    // wild (win case), delay added b/w steps + win sound get playing
                    if (!WGEnginePlayer._noWin) {
                        this.pTimeline.add(() => {
                            if (!this._abortSounds)
                                SoundManager.playSoundEffect(WGSoundConfig.instance.WILD_NUDGE_WIN[j]);
                        });
                        this.pTimeline.to({}, 0.2, this.pTimeline.time());
                    }
                }
                this.pTimeline.add(()=>{
                    WarriorGraveyardGameModuleConfig.anticipationAnimation.stopWildLandingByReelId(i);
                });
            }
            if (this._wildMultipliers[i] === 0 && !this._doReelNudge[i]) { // show x1 on wild
                this.pTimeline.add(() => {
                    if (this._wildNudgesoundX1reels.indexOf(i + 1) === -1 && (this._nudgeData.symbolWinStates[i].includes(true)||
                        this._nudgeData.mode===GameMode.FREESPIN)) {
                        SoundManager.playSoundEffect(WGSoundConfig.instance.WILD_NO_NUDGE);
                    }
                    this.nudgeStepCompleted(i, true);
                    WarriorGraveyardGameModuleConfig.anticipationAnimation.stopWildLandingByReelId(i);

                });
            }
        }
        this.pTimeline.add(() => {
            EventHandler.dispatchEvent(new GameEvent(SpinEvent.WANT_SKIPPABLE));
        }, this._nudgeData.totalWin === 0 ? 0 : 0.3);
        this.pTimeline.add(() => {
            WarriorGraveyardGameModuleConfig.anticipationAnimation.stopAllWildLanding();
            this.PresentationState.set(PresentationState.END);
        });
    }

    public skipPresentation(): void {
        this._abortSounds = true;
        // play abort sounds
        if(!WGEnginePlayer._noWin) {
            SoundManager.playSoundEffect(WGSoundConfig.instance.WILD_NUDGE_WIN[0]);
        }

        WGEnginePlayer.noWin = true;
        this.pTimeline.timeScale(20);
    }

    /**
     * function to calculation nudge steps base on their multiplier
     * and direction with the help of half symbol index.
     */
    private getStepsForNudge(): number[] {
        for (let i = 0; i < this._wildMultipliers.length; i++) {
            this._wildMultipliers[i] -= 1;
            if (this._wildMultipliers[i] > 0) {
                if (this._nudgeData.actualReels[i][4].indexOf("W") > -1) {
                    this._wildMultipliers[i] = -this._wildMultipliers[i];
                }
                this._doReelNudge[i] = true;
            }
        }
        return this._wildMultipliers;
    }

    /**
     * function called when state set to end
     */
    public stopPresentation(): void {
        EventHandler.removeEventListener(this, NudgeEvents.REEL_NUDGE_STEP_COMPLETED);
        this._doReelNudge = [false, false, false, false, false, false];
        this.PresentationState.set(PresentationState.INACTIVE);
        this._wildMultiplieronSymbols = [-1, 1, 1, 1, 1, -1];
        this._wildMulitplierGlow.forEach(value => value.visible = false);

        WildNudgePresentation._wildNudgeStarted = false;

    }

    /**
     * function to spin mutltipliers with symbol after wild nudge
     * @param reelId
     */
    private spinMultiplierWithSymbol(reelId: number): void {
        reelId = reelId - 1;
        this._wildMulitplierGlow.forEach(value => value.visible = false);
        if (!WildNudgePresentation._wildMultiplierContainer[reelId].visible) {
            return;
        }
        let reelEngineConfig = WGGameConfig.instance.REEL_ENGINE_CONFIG.DURATION;
        let sym = WGEngineManager.getReel(reelId + 1).getSymbol(1);
        TweenLite.to(WildNudgePresentation._wildMultiplierContainer[reelId], GameSetting.isFastSpin ? reelEngineConfig.QUICK_START : reelEngineConfig.START, {
            onUpdate: () => {
                WildNudgePresentation._wildMultiplierContainer[reelId].position.y =
                    Helper.copyLocalPosition(WildNudgePresentation._wildMultiplierContainer[reelId], sym!).y;
                WildNudgePresentation._wildMultiplierContainer[reelId].position.y += 30;
            },
            onComplete: () => {
                WildNudgePresentation._wildMultiplierContainer[reelId].visible = false;
            }
        });

    }
}
